export enum SortedOrder {
    ASC = "ASC", DSC = "DSC"
}